// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"302":"loginView","505":"rechargeview"}[chunkId] || chunkId) + "." + {"302":"fb0a2ec2","485":"5db1ecc8","505":"3bc1337d"}[chunkId] + ".js";
};